<template>
    <div class="user_profile bg-gradient-primary bd-callout bd-callout-success position-relative mt-2  px-2 p-1"
         :class="{'cursor-pointer':show_select}" v-on:click="push_in_select">
        <div class="d-flex flex-row pt-2 pb-1" :class="checked_item">
            <span class="status">
                <img v-if="obj_to_null(product_image)" class="profile-image rounded-circle d-inline-block" :src="product_image">
            </span>

            <span class="position-absolute pos-right pr-3 remove" v-on:click.stop.prevent="remove_item" v-if="show_remove">
                  <span class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                      <i class="fal fa-times"></i>
                  </span>
            </span>

            <div class="user_attrib ml-3">
                <div class="name d-block fw-700 text-dark">
                    {{ product_title }}
                </div>

                <div class="company small text-dark badge badge-success" v-if="product.hasOwnProperty('main_categ')">
                    {{ product.main_categ.title }}
                </div>

                <div class="company small text-dark">
                    {{ product.uniq_id }}
                </div>
                </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "product_inside",
    props: {
        product: {
            type: Object
        },
        show_remove: {
            type: Boolean,
            default: true,
        },
        show_select : {
            type: Boolean,
            default: true,
        }
    },

    methods: {
        push_in_select() {
            this.$emit('select_product',this.product.id);
        },

        remove_item() {
            this.$emit('remove_product',this.product.id);
        },
    },

    computed: {

        product_title() {
            if (this.product.hasOwnProperty('title')) {
                return this.product.title;
            }
            return "ID:" + this.product.id;
        },

        checked_item() {
            if (!this.product.is_selected) {
                return '';
            }

            return 'active bg-selected-50';
        },

        product_image() {
            if (this.product.hasOwnProperty('main_photo')) {
                return this.product.main_photo.webp;
            }
            return null;
        }
    }


}
</script>

<style scoped>

</style>
